import { Resume } from '@sr/types';
import { useThemeUI } from 'theme-ui';
import { ResumeTheme } from '../common/base-theme';
import { getCalcSize } from '../common/calc-size';
import Divider from '../common/Divider';
import { Box, Heading, ResumeHeading, Text, WebsiteLink } from '../common/ui';
import ColorBlob from './ColorBlob';

const Header = ({ resume }: { resume: Resume }) => {
  const theme = useThemeUI().theme as ResumeTheme;
  const calcSize = getCalcSize(theme.baseSize);
  const {
    city,
    email,
    firstName,
    lastName,
    phone,
    state,
    summary,
    title,
    website,
    website2,
  } = resume.about;
  const location = (city || state) && (
    <Divider divider=", ">
      {city}
      {state}
    </Divider>
  );
  const name = `${firstName} ${lastName}`;
  return (
    <>
      <Box
        as="header"
        variant="headerContainer"
        className="pdf-resume-header"
        sx={{
          position: 'relative',
        }}
      >
        <Box
          sx={{
            mb: calcSize(2.5),
            display: 'flex',
            flexWrap: ['wrap', 'nowrap'],
            flexDirection: ['column', 'row'],
            justifyContent: ['normal', 'space-between'],
          }}
        >
          <ResumeHeading>{name}</ResumeHeading>
          <Box
            sx={{
              '@media screen and (min-width: 35em)': {
                display: 'grid',
                gridAutoFlow: 'column',
                gridAutoColumns: 'max-content',
                gridTemplateRows: '1fr 1fr',
                columnGap: 48,
                flexGrow: 1,
                justifyContent: 'flex-end',
              },
              pr: [0, 48],
              mt: [16, 0],
            }}
          >
            {location && <Text>{location}</Text>}
            {email && <Text>{email}</Text>}
            {website && (
              <Text>
                <WebsiteLink url={website} />
              </Text>
            )}
            {website2 && (
              <Text>
                <WebsiteLink url={website2} />
              </Text>
            )}
            {phone && <Text>{phone}</Text>}
          </Box>
        </Box>
        <Heading variant="resumeSummary">
          {title && (
            <>
              <Text
                sx={{
                  fontStyle: 'italic',
                }}
                variant="resumeSummary"
                as="span"
              >
                {title}
              </Text>
              {'  — '}
            </>
          )}
          {summary}
        </Heading>
        <ColorBlob />
      </Box>
    </>
  );
};

export default Header;
